module.exports = __webpack_public_path__ + "d98c9cf877a887b7deb4796283f341c1.fbx";